// extracted by mini-css-extract-plugin
export default {"background_wrapper":"BackgroundShortz_background_wrapper__1Jyxs","wrapper":"BackgroundShortz_wrapper__83a04","paddingBottom":"BackgroundShortz_paddingBottom__Wvgax"};